import { useEffect, useState } from "react";
import type { ReviewAnsicht } from "../api";
import { euro } from "../geld";

interface Props {
  review: ReviewAnsicht;
  laedt: boolean;
  onBestaetigen: (code: string) => void;
  onZurueck: () => void;
}

/** Der Review vor der Bestätigung: die eingefrorenen Zeilen und Summen plus die Code-Eingabe.
 *  Liefert der Dev-Bypass einen `code`, füllen wir ihn vor. */
export function OtpBestaetigung({ review, laedt, onBestaetigen, onZurueck }: Props) {
  const [code, setCode] = useState(review.code ?? "");

  useEffect(() => {
    if (review.code) setCode(review.code);
  }, [review.code]);

  const absenden = (e: React.FormEvent) => {
    e.preventDefault();
    onBestaetigen(code.trim());
  };

  return (
    <section className="review">
      <h2>Bestellung prüfen</h2>
      <ul className="review-zeilen">
        {review.zeilen.map((zeile, i) => (
          <li key={`${zeile.name}-${i}`}>
            <span>{zeile.name}</span>
            <span>{euro(zeile.zeilensummeCent)}</span>
          </li>
        ))}
      </ul>
      <dl className="summen">
        <div>
          <dt>Liefergebühr</dt>
          <dd>{euro(review.liefergebuehrCent)}</dd>
        </div>
        <div className="gesamt">
          <dt>Gesamtsumme</dt>
          <dd>{euro(review.gesamtsummeCent)}</dd>
        </div>
      </dl>

      {review.code && (
        <p className="dev-hinweis">
          Test-Modus: der Code <code>{review.code}</code> wurde vorausgefüllt.
        </p>
      )}

      <form className="code-form" onSubmit={absenden}>
        <label className="feld">
          <span>Bestätigungscode (SMS)</span>
          <input
            inputMode="numeric"
            autoComplete="one-time-code"
            required
            value={code}
            onChange={(e) => setCode(e.target.value)}
            placeholder="6-stelliger Code"
          />
        </label>
        <div className="knopf-reihe">
          <button type="button" className="knopf sekundaer" onClick={onZurueck} disabled={laedt}>
            Zurück
          </button>
          <button type="submit" className="knopf primaer" disabled={laedt}>
            {laedt ? "Wird bestätigt …" : "Bestellung bestätigen"}
          </button>
        </div>
      </form>
    </section>
  );
}
